import React from "react";

import ImageLeftProcessRightSlice from "../../components/slices/imageLeftProcessRight/ImageLeftProcessRightSlice";

const ImageLeftProcessRight = ({ slice }) => {
  return <ImageLeftProcessRightSlice slice={slice} />;
};

export default ImageLeftProcessRight;
